// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalFooter_container__3LyT_","content":"ModalFooter_content__2H1Si","actions":"ModalFooter_actions__1LB5w"};